import { Spin } from 'antd';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { routes } from '@/config/routes';
import { useAuth } from '@/providers/auth-provider';

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'unknown') {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }
  if (status === 'unauthenticated') {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`${routes.login}?next=${next}`} replace />;
  }
  return <Outlet />;
}
